import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetNetworkCombosRequest = () =>
	AxiosRequest({ method: 'GET', url: `${config.API_URL}ActivityMap/GetNetworkCombos` });

// Type (Feature) list + colours — same TrackerFeature lookup used by the Activity
// Tracker module (Id/Name/Color/SortOrder), so both stay in sync automatically.
export const GetFeatureTypesRequest = () =>
	AxiosRequest({ method: 'GET', url: `${config.API_URL}ActivityTracker/GetFeatures` });

export const GetAllSitesRequest = (filters) => {
	const params = {};
	if (filters.technologies?.length === 1) params.technology  = filters.technologies[0];
	if (filters.vendors?.length      === 1) params.vendor      = filters.vendors[0];
	if (filters.servers?.length      === 1) params.server      = filters.servers[0];
	if (filters.tacs?.length         === 1) params.tac         = filters.tacs[0];
	if (filters.sides?.length        === 1) params.side        = filters.sides[0];
	if (filters.startDate)                  params.windowStart = filters.startDate;
	if (filters.endDate)                    params.windowEnd   = filters.endDate;
	return AxiosRequest({ method: 'GET', url: `${config.API_URL}ActivityMap/GetAllSites`, params });
};

export const GetActivityTitlesRequest = (filters) => {
	const params = {};
	if (filters.technologies?.length === 1) params.technology  = filters.technologies[0];
	if (filters.vendors?.length      === 1) params.vendor      = filters.vendors[0];
	if (filters.servers?.length      === 1) params.server      = filters.servers[0];
	if (filters.tacs?.length         === 1) params.tac         = filters.tacs[0];
	if (filters.sides?.length        === 1) params.side        = filters.sides[0];
	if (filters.startDate)                  params.windowStart = filters.startDate;
	if (filters.endDate)                    params.windowEnd   = filters.endDate;
	// Type is multi-select, unlike the fields above — sent as a comma-separated
	// list so titles with no matching activity Type are excluded server-side.
	if (filters.features?.length > 0)       params.types       = filters.features.join(',');
	return AxiosRequest({ method: 'GET', url: `${config.API_URL}ActivityMap/GetActivityTitles`, params });
};

export const GetSiteActivitiesRequest = ({ csr, technology, vendor, omcId, tac, activityStatus, startDate, endDate }) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}ActivityMap/GetSiteActivities`,
		params: { csr, technology, vendor, omcId, tac, activityStatus, windowStart: startDate, windowEnd: endDate },
	});